// clinicSetting/saga.js
import { call, put, takeLatest } from "redux-saga/effects"
import { FETCH_LEAVE_DAYS } from "./actionTypes"
import { fetchLeaveDaysSuccess, fetchLeaveDaysFailure } from "./action"
import { getClinicSetting } from "../../pages/Extra Pages/clinicSettingApi"

function* fetchLeaveDaysSaga() {
  try {
    const response = yield call(getClinicSetting)

    //  Ensure leaveDays is always an array
    const leaveDays = Array.isArray(response?.leaveDays)
      ? response.leaveDays
      : []

    console.log("✅ Saga received leaveDays:", leaveDays)
    yield put(fetchLeaveDaysSuccess(leaveDays))
  } catch (error) {
    yield put(fetchLeaveDaysFailure(error.message))
  }
}

export default function* clinicSettingSaga() {
  yield takeLatest(FETCH_LEAVE_DAYS, fetchLeaveDaysSaga)
}
